var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    zoomAndPan: "magnify",
    viewBox: "0 0 1080 534.000001",
    height: 712,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "a6ba601bd2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "111ac74054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.007812 0 L 1078.988281 0 L 1078.988281 533 L 1.007812 533 Z M 1.007812 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    gradientTransform: "matrix(0.748598, 0, 0, 0.748598, 1.009344, 0.0000199626)",
    y1: 356,
    x2: 1439.99994,
    gradientUnits: "userSpaceOnUse",
    y2: 356,
    id: "8aef042000"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.099487%, 12.89978%, 63.499451%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.178833%, 12.979126%, 63.60321%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.337524%, 13.137817%, 63.812256%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.497742%, 13.298035%, 64.022827%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.656433%, 13.456726%, 64.231873%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.81665%, 13.615417%, 64.440918%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.975342%, 13.775635%, 64.649963%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.135559%, 13.934326%, 64.859009%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.29425%, 14.094543%, 65.06958%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.452942%, 14.253235%, 65.278625%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.613159%, 14.413452%, 65.487671%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.771851%, 14.572144%, 65.696716%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.932068%, 14.732361%, 65.905762%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.090759%, 14.891052%, 66.116333%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.250977%, 15.049744%, 66.325378%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.409668%, 15.209961%, 66.534424%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.569885%, 15.368652%, 66.743469%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.728577%, 15.52887%, 66.954041%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.887268%, 15.687561%, 67.163086%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.047485%, 15.847778%, 67.372131%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.206177%, 16.00647%, 67.581177%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.366394%, 16.166687%, 67.790222%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.525085%, 16.325378%, 68.000793%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.685303%, 16.48407%, 68.209839%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.843994%, 16.644287%, 68.418884%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.004211%, 16.802979%, 68.62793%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.162903%, 16.963196%, 68.836975%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.321594%, 17.121887%, 69.047546%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.481812%, 17.282104%, 69.256592%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.640503%, 17.440796%, 69.465637%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.80072%, 17.601013%, 69.674683%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.959412%, 17.759705%, 69.885254%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.119629%, 17.919922%, 70.094299%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.27832%, 18.078613%, 70.303345%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.438538%, 18.237305%, 70.51239%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.597229%, 18.397522%, 70.721436%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.757446%, 18.556213%, 70.932007%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.916138%, 18.716431%, 71.141052%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.074829%, 18.875122%, 71.350098%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.235046%, 19.035339%, 71.559143%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.393738%, 19.194031%, 71.768188%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.553955%, 19.354248%, 71.97876%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.712646%, 19.512939%, 72.187805%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.872864%, 19.671631%, 72.396851%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.031555%, 19.831848%, 72.605896%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.191772%, 19.99054%, 72.816467%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.350464%, 20.150757%, 73.025513%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.509155%, 20.309448%, 73.234558%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.669373%, 20.469666%, 73.443604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.828064%, 20.628357%, 73.652649%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.988281%, 20.788574%, 73.86322%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.146973%, 20.947266%, 74.072266%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.30719%, 21.105957%, 74.281311%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.465881%, 21.266174%, 74.490356%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.626099%, 21.424866%, 74.700928%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.78479%, 21.585083%, 74.909973%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.943481%, 21.743774%, 75.119019%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.103699%, 21.903992%, 75.328064%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.26239%, 22.062683%, 75.537109%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.422607%, 22.2229%, 75.747681%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.581299%, 22.381592%, 75.956726%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.741516%, 22.541809%, 76.165771%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.900208%, 22.7005%, 76.374817%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 22.859192%, 76.583862%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.219116%, 23.019409%, 76.794434%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.388489%, 23.196411%, 77.0401%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.565491%, 23.39325%, 77.320862%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.744019%, 23.590088%, 77.601624%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.922546%, 23.786926%, 77.883911%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.099548%, 23.983765%, 78.164673%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.278076%, 24.180603%, 78.445435%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.456604%, 24.377441%, 78.727722%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.635132%, 24.575806%, 79.008484%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.812134%, 24.772644%, 79.289246%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.990662%, 24.969482%, 79.571533%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.169189%, 25.166321%, 79.852295%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.347717%, 25.363159%, 80.133057%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.524719%, 25.559998%, 80.415344%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.703247%, 25.756836%, 80.696106%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.881775%, 25.953674%, 80.976868%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.060303%, 26.150513%, 81.257629%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.237305%, 26.347351%, 81.539917%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.415833%, 26.544189%, 81.820679%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.59436%, 26.741028%, 82.10144%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.771362%, 26.937866%, 82.383728%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.94989%, 27.134705%, 82.66449%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.128418%, 27.331543%, 82.945251%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.306946%, 27.528381%, 83.227539%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.483948%, 27.72522%, 83.508301%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.662476%, 27.922058%, 83.789062%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.841003%, 28.118896%, 84.07135%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.019531%, 28.315735%, 84.352112%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.196533%, 28.512573%, 84.632874%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.375061%, 28.709412%, 84.915161%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.553589%, 28.90625%, 85.195923%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.732117%, 29.103088%, 85.476685%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.909119%, 29.299927%, 85.758972%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.087646%, 29.496765%, 86.039734%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.266174%, 29.693604%, 86.320496%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.444702%, 29.890442%, 86.602783%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.621704%, 30.08728%, 86.883545%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.800232%, 30.284119%, 87.164307%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.97876%, 30.480957%, 87.446594%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.155762%, 30.677795%, 87.727356%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.33429%, 30.874634%, 88.008118%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.512817%, 31.071472%, 88.288879%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.691345%, 31.268311%, 88.571167%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.868347%, 31.465149%, 88.851929%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.046875%, 31.661987%, 89.13269%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.225403%, 31.858826%, 89.414978%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.403931%, 32.055664%, 89.69574%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.580933%, 32.252502%, 89.976501%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.75946%, 32.449341%, 90.258789%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.937988%, 32.646179%, 90.539551%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.116516%, 32.844543%, 90.820312%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.293518%, 33.041382%, 91.1026%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.472046%, 33.23822%, 91.383362%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.650574%, 33.435059%, 91.664124%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.829102%, 33.631897%, 91.946411%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.006104%, 33.828735%, 92.227173%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.184631%, 34.025574%, 92.507935%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.363159%, 34.222412%, 92.790222%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.540161%, 34.41925%, 93.070984%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.718689%, 34.616089%, 93.351746%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.897217%, 34.812927%, 93.634033%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.075745%, 35.009766%, 93.914795%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.252747%, 35.206604%, 94.195557%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.431274%, 35.403442%, 94.477844%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.609802%, 35.600281%, 94.758606%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e64749dd72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 476 0 L 1078.988281 0 L 1078.988281 533 L 476 533 Z M 476 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1b84670f26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.09
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "895c778fe8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.835938 0 L 602.988281 0 L 602.988281 533 L 93.835938 533 Z M 93.835938 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76cbd6cea1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.164062 -32.433594 C 261.429688 -32.433594 93.835938 124.476562 93.835938 318.035156 C 93.835938 511.589844 261.429688 668.5 468.164062 668.5 C 674.902344 668.5 842.492188 511.589844 842.492188 318.035156 C 842.492188 124.476562 674.902344 -32.433594 468.164062 -32.433594 Z M 468.164062 -32.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2b34f139f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.835938 0 L 602.988281 0 L 602.988281 533 L 93.835938 533 Z M 93.835938 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3d6ad4d823"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.164062 -32.433594 C 261.429688 -32.433594 93.835938 124.476562 93.835938 318.035156 C 93.835938 511.589844 261.429688 668.5 468.164062 668.5 C 674.898438 668.5 842.492188 511.589844 842.492188 318.035156 C 842.492188 124.476562 674.898438 -32.433594 468.164062 -32.433594 Z M 468.164062 -32.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "022c06ce28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 603,
    y: 0,
    height: 533
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a5f2d03330"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f72d8f2512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.960938 L 17.640625 0.960938 L 17.640625 16.257812 L 0.253906 16.257812 Z M 0.253906 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44956d1a95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.960938 C 4.132812 0.960938 0.253906 4.386719 0.253906 8.609375 C 0.253906 12.832031 4.132812 16.257812 8.921875 16.257812 C 13.707031 16.257812 17.589844 12.832031 17.589844 8.609375 C 17.589844 4.386719 13.707031 0.960938 8.921875 0.960938 Z M 8.921875 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6cf1776dce"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c6a8ce959d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "89676c334e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.648438 L 17.640625 0.648438 L 17.640625 15.945312 L 0.253906 15.945312 Z M 0.253906 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1cb6dd407"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.648438 C 4.132812 0.648438 0.253906 4.070312 0.253906 8.296875 C 0.253906 12.519531 4.132812 15.945312 8.921875 15.945312 C 13.707031 15.945312 17.589844 12.519531 17.589844 8.296875 C 17.589844 4.070312 13.707031 0.648438 8.921875 0.648438 Z M 8.921875 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d1bb6c893"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "71ef1a05a1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f80b608562"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.207031 L 17.640625 0.207031 L 17.640625 15.503906 L 0.253906 15.503906 Z M 0.253906 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f06bfecbf1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.207031 C 4.132812 0.207031 0.253906 3.628906 0.253906 7.855469 C 0.253906 12.078125 4.132812 15.503906 8.921875 15.503906 C 13.707031 15.503906 17.589844 12.078125 17.589844 7.855469 C 17.589844 3.628906 13.707031 0.207031 8.921875 0.207031 Z M 8.921875 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd12300390"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "25550c89ff"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f47ffcc4cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.894531 L 17.640625 0.894531 L 17.640625 16.191406 L 0.253906 16.191406 Z M 0.253906 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9898c93484"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.894531 C 4.132812 0.894531 0.253906 4.316406 0.253906 8.542969 C 0.253906 12.765625 4.132812 16.191406 8.921875 16.191406 C 13.707031 16.191406 17.589844 12.765625 17.589844 8.542969 C 17.589844 4.316406 13.707031 0.894531 8.921875 0.894531 Z M 8.921875 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "590c3602e1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d2ff90d8d9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9857422f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.960938 L 18.472656 0.960938 L 18.472656 16.257812 L 1.085938 16.257812 Z M 1.085938 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ada1f80a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.960938 C 4.964844 0.960938 1.085938 4.386719 1.085938 8.609375 C 1.085938 12.832031 4.964844 16.257812 9.753906 16.257812 C 14.539062 16.257812 18.421875 12.832031 18.421875 8.609375 C 18.421875 4.386719 14.539062 0.960938 9.753906 0.960938 Z M 9.753906 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72d45878ad"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "41f0c188f9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d6942f6e85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.960938 L 18.199219 0.960938 L 18.199219 16.257812 L 0.808594 16.257812 Z M 0.808594 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8bcc685215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.960938 C 4.691406 0.960938 0.808594 4.386719 0.808594 8.609375 C 0.808594 12.832031 4.691406 16.257812 9.480469 16.257812 C 14.265625 16.257812 18.148438 12.832031 18.148438 8.609375 C 18.148438 4.386719 14.265625 0.960938 9.480469 0.960938 Z M 9.480469 0.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1bb581a9bc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "72ab131978"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9b0daab27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.648438 L 18.472656 0.648438 L 18.472656 15.945312 L 1.085938 15.945312 Z M 1.085938 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "103ec75c92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.648438 C 4.964844 0.648438 1.085938 4.070312 1.085938 8.296875 C 1.085938 12.519531 4.964844 15.945312 9.753906 15.945312 C 14.539062 15.945312 18.421875 12.519531 18.421875 8.296875 C 18.421875 4.070312 14.539062 0.648438 9.753906 0.648438 Z M 9.753906 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc5a66dffb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "951e65239a"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "41385cea7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.207031 L 18.472656 0.207031 L 18.472656 15.503906 L 1.085938 15.503906 Z M 1.085938 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2dff4331a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.207031 C 4.964844 0.207031 1.085938 3.628906 1.085938 7.855469 C 1.085938 12.078125 4.964844 15.503906 9.753906 15.503906 C 14.539062 15.503906 18.421875 12.078125 18.421875 7.855469 C 18.421875 3.628906 14.539062 0.207031 9.753906 0.207031 Z M 9.753906 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5e2392ab2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "59f0fad7b2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "39012010f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.648438 L 18.199219 0.648438 L 18.199219 15.945312 L 0.808594 15.945312 Z M 0.808594 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f5259b7f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.648438 C 4.691406 0.648438 0.808594 4.070312 0.808594 8.296875 C 0.808594 12.519531 4.691406 15.945312 9.480469 15.945312 C 14.265625 15.945312 18.148438 12.519531 18.148438 8.296875 C 18.148438 4.070312 14.265625 0.648438 9.480469 0.648438 Z M 9.480469 0.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "938aa624d7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fdac8b7916"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d12a622e8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.894531 L 18.472656 0.894531 L 18.472656 16.191406 L 1.085938 16.191406 Z M 1.085938 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "51a99d7665"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.894531 C 4.964844 0.894531 1.085938 4.316406 1.085938 8.542969 C 1.085938 12.765625 4.964844 16.191406 9.753906 16.191406 C 14.539062 16.191406 18.421875 12.765625 18.421875 8.542969 C 18.421875 4.316406 14.539062 0.894531 9.753906 0.894531 Z M 9.753906 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0027de04aa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "9c7b9e954e"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7b96e5879"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.207031 L 18.199219 0.207031 L 18.199219 15.503906 L 0.808594 15.503906 Z M 0.808594 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c82b9f7e47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.207031 C 4.691406 0.207031 0.808594 3.628906 0.808594 7.855469 C 0.808594 12.078125 4.691406 15.503906 9.480469 15.503906 C 14.265625 15.503906 18.148438 12.078125 18.148438 7.855469 C 18.148438 3.628906 14.265625 0.207031 9.480469 0.207031 Z M 9.480469 0.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de960a0f7f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ff2f65d45c"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c12647447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.894531 L 18.199219 0.894531 L 18.199219 16.191406 L 0.808594 16.191406 Z M 0.808594 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba23e6de06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.894531 C 4.691406 0.894531 0.808594 4.316406 0.808594 8.542969 C 0.808594 12.765625 4.691406 16.191406 9.480469 16.191406 C 14.265625 16.191406 18.148438 12.765625 18.148438 8.542969 C 18.148438 4.316406 14.265625 0.894531 9.480469 0.894531 Z M 9.480469 0.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1615c02f1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "360f3ea620"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2085d606d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.578125 L 17.640625 0.578125 L 17.640625 15.875 L 0.253906 15.875 Z M 0.253906 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8ad3edbd8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.578125 C 4.132812 0.578125 0.253906 4.003906 0.253906 8.226562 C 0.253906 12.453125 4.132812 15.875 8.921875 15.875 C 13.707031 15.875 17.589844 12.453125 17.589844 8.226562 C 17.589844 4.003906 13.707031 0.578125 8.921875 0.578125 Z M 8.921875 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "767200edfa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0d70e7e20f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac577808a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.265625 L 17.640625 0.265625 L 17.640625 15.5625 L 0.253906 15.5625 Z M 0.253906 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38806ecc3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.265625 C 4.132812 0.265625 0.253906 3.691406 0.253906 7.914062 C 0.253906 12.140625 4.132812 15.5625 8.921875 15.5625 C 13.707031 15.5625 17.589844 12.140625 17.589844 7.914062 C 17.589844 3.691406 13.707031 0.265625 8.921875 0.265625 Z M 8.921875 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c701e152f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "6fa29a67fb"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "10bf037f58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.253906 0.824219 L 17.640625 0.824219 L 17.640625 16.121094 L 0.253906 16.121094 Z M 0.253906 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58cd3b10fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.921875 0.824219 C 4.132812 0.824219 0.253906 4.25 0.253906 8.472656 C 0.253906 12.699219 4.132812 16.121094 8.921875 16.121094 C 13.707031 16.121094 17.589844 12.699219 17.589844 8.472656 C 17.589844 4.25 13.707031 0.824219 8.921875 0.824219 Z M 8.921875 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0bc6aad9b0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 18,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d2c627dfea"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "7730fe1c3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.578125 L 18.472656 0.578125 L 18.472656 15.875 L 1.085938 15.875 Z M 1.085938 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "969a652df7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.578125 C 4.964844 0.578125 1.085938 4.003906 1.085938 8.226562 C 1.085938 12.453125 4.964844 15.875 9.753906 15.875 C 14.539062 15.875 18.421875 12.453125 18.421875 8.226562 C 18.421875 4.003906 14.539062 0.578125 9.753906 0.578125 Z M 9.753906 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46f3fafbb4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0082a7653f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e2f576f434"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.578125 L 18.199219 0.578125 L 18.199219 15.875 L 0.808594 15.875 Z M 0.808594 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5029d01429"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.578125 C 4.691406 0.578125 0.808594 4.003906 0.808594 8.226562 C 0.808594 12.453125 4.691406 15.875 9.480469 15.875 C 14.265625 15.875 18.148438 12.453125 18.148438 8.226562 C 18.148438 4.003906 14.265625 0.578125 9.480469 0.578125 Z M 9.480469 0.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "529fc0cd01"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "76bf108c5f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "50c8caa0db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.265625 L 18.472656 0.265625 L 18.472656 15.5625 L 1.085938 15.5625 Z M 1.085938 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6882cb4efd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.265625 C 4.964844 0.265625 1.085938 3.691406 1.085938 7.914062 C 1.085938 12.140625 4.964844 15.5625 9.753906 15.5625 C 14.539062 15.5625 18.421875 12.140625 18.421875 7.914062 C 18.421875 3.691406 14.539062 0.265625 9.753906 0.265625 Z M 9.753906 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "406777f744"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3bb98e6768"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "453a861d60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.085938 0.824219 L 18.472656 0.824219 L 18.472656 16.121094 L 1.085938 16.121094 Z M 1.085938 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "81154b7f05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.753906 0.824219 C 4.964844 0.824219 1.085938 4.25 1.085938 8.472656 C 1.085938 12.699219 4.964844 16.121094 9.753906 16.121094 C 14.539062 16.121094 18.421875 12.699219 18.421875 8.472656 C 18.421875 4.25 14.539062 0.824219 9.753906 0.824219 Z M 9.753906 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb2af828eb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "20d7111e79"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d194636839"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.265625 L 18.199219 0.265625 L 18.199219 15.5625 L 0.808594 15.5625 Z M 0.808594 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67e0f80247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.265625 C 4.691406 0.265625 0.808594 3.691406 0.808594 7.914062 C 0.808594 12.140625 4.691406 15.5625 9.480469 15.5625 C 14.265625 15.5625 18.148438 12.140625 18.148438 7.914062 C 18.148438 3.691406 14.265625 0.265625 9.480469 0.265625 Z M 9.480469 0.265625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13f346bcb1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eb039ec984"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c833a4d29a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.808594 0.824219 L 18.199219 0.824219 L 18.199219 16.121094 L 0.808594 16.121094 Z M 0.808594 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "22082a985f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.480469 0.824219 C 4.691406 0.824219 0.808594 4.25 0.808594 8.472656 C 0.808594 12.699219 4.691406 16.121094 9.480469 16.121094 C 14.265625 16.121094 18.148438 12.699219 18.148438 8.472656 C 18.148438 4.25 14.265625 0.824219 9.480469 0.824219 Z M 9.480469 0.824219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed2ad6529d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 17
  })), /*#__PURE__*/React.createElement("mask", {
    id: "3fba96cf06"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.06
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "64f548a546"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.09375 0.441406 L 210.085938 0.441406 L 210.085938 210.433594 L 0.09375 210.433594 Z M 0.09375 0.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f8bc9153d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.089844 0.441406 C 47.101562 0.441406 0.09375 47.449219 0.09375 105.4375 C 0.09375 163.421875 47.101562 210.433594 105.089844 210.433594 C 163.078125 210.433594 210.085938 163.421875 210.085938 105.4375 C 210.085938 47.449219 163.078125 0.441406 105.089844 0.441406 Z M 105.089844 0.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90686f8e67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 211,
    y: 0,
    height: 211
  })), /*#__PURE__*/React.createElement("mask", {
    id: "206f01993f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.06
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1ffb6c8e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.742188 1.027344 L 121.148438 1.027344 L 121.148438 121.433594 L 0.742188 121.433594 Z M 0.742188 1.027344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea83372f6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.945312 1.027344 C 27.695312 1.027344 0.742188 27.980469 0.742188 61.230469 C 0.742188 94.476562 27.695312 121.433594 60.945312 121.433594 C 94.191406 121.433594 121.148438 94.476562 121.148438 61.230469 C 121.148438 27.980469 94.191406 1.027344 60.945312 1.027344 Z M 60.945312 1.027344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "674ef19dd0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 122,
    y: 0,
    height: 122
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc73dca021"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.007812 426 L 133 426 L 133 533 L 1.007812 533 Z M 1.007812 426 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aef9066ba4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -108,
    width: 1296,
    fill: "#000000",
    y: -53.4,
    height: 640.800002,
    fillOpacity: 0.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd1f6247b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0078125 0.402344 L 131 0.402344 L 131 107 L 0.0078125 107 Z M 0.0078125 0.402344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9287d418eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 130.976562 107 C 130.976562 108.746094 130.933594 110.488281 130.847656 112.230469 C 130.761719 113.972656 130.632812 115.714844 130.464844 117.449219 C 130.292969 119.183594 130.078125 120.917969 129.824219 122.640625 C 129.566406 124.367188 129.269531 126.085938 128.929688 127.796875 C 128.585938 129.507812 128.207031 131.210938 127.78125 132.902344 C 127.359375 134.59375 126.890625 136.273438 126.386719 137.945312 C 125.878906 139.613281 125.332031 141.269531 124.746094 142.914062 C 124.15625 144.554688 123.53125 146.183594 122.863281 147.792969 C 122.195312 149.40625 121.488281 151 120.742188 152.578125 C 119.996094 154.15625 119.210938 155.710938 118.390625 157.25 C 117.566406 158.789062 116.707031 160.308594 115.808594 161.804688 C 114.914062 163.300781 113.980469 164.773438 113.011719 166.222656 C 112.042969 167.675781 111.039062 169.101562 110 170.5 C 108.960938 171.902344 107.886719 173.277344 106.78125 174.625 C 105.671875 175.976562 104.535156 177.296875 103.363281 178.589844 C 102.191406 179.882812 100.988281 181.144531 99.753906 182.378906 C 98.519531 183.609375 97.257812 184.8125 95.964844 185.984375 C 94.671875 187.15625 93.351562 188.296875 92.003906 189.402344 C 90.65625 190.507812 89.28125 191.582031 87.878906 192.621094 C 86.476562 193.660156 85.050781 194.664062 83.601562 195.632812 C 82.148438 196.605469 80.675781 197.535156 79.179688 198.433594 C 77.683594 199.332031 76.167969 200.191406 74.628906 201.011719 C 73.089844 201.835938 71.53125 202.621094 69.953125 203.363281 C 68.378906 204.109375 66.78125 204.816406 65.171875 205.484375 C 63.558594 206.152344 61.933594 206.78125 60.289062 207.367188 C 58.648438 207.957031 56.992188 208.503906 55.320312 209.007812 C 53.652344 209.515625 51.972656 209.980469 50.277344 210.40625 C 48.585938 210.828125 46.882812 211.210938 45.171875 211.550781 C 43.460938 211.890625 41.742188 212.191406 40.019531 212.445312 C 38.292969 212.703125 36.5625 212.914062 34.824219 213.085938 C 33.089844 213.257812 31.351562 213.386719 29.609375 213.472656 C 27.863281 213.558594 26.121094 213.601562 24.378906 213.601562 C 22.632812 213.601562 20.890625 213.558594 19.148438 213.472656 C 17.402344 213.386719 15.664062 213.257812 13.929688 213.085938 C 12.191406 212.914062 10.460938 212.703125 8.734375 212.445312 C 7.011719 212.191406 5.292969 211.890625 3.582031 211.550781 C 1.871094 211.210938 0.167969 210.828125 -1.523438 210.40625 C -3.214844 209.980469 -4.898438 209.515625 -6.566406 209.007812 C -8.238281 208.503906 -9.890625 207.957031 -11.535156 207.367188 C -13.175781 206.78125 -14.804688 206.152344 -16.417969 205.484375 C -18.027344 204.816406 -19.621094 204.109375 -21.199219 203.363281 C -22.777344 202.621094 -24.335938 201.835938 -25.875 201.011719 C -27.410156 200.191406 -28.929688 199.332031 -30.425781 198.433594 C -31.921875 197.535156 -33.394531 196.605469 -34.847656 195.632812 C -36.296875 194.664062 -37.722656 193.660156 -39.125 192.621094 C -40.523438 191.582031 -41.898438 190.507812 -43.25 189.402344 C -44.597656 188.296875 -45.917969 187.15625 -47.210938 185.984375 C -48.503906 184.8125 -49.765625 183.609375 -51 182.378906 C -52.234375 181.144531 -53.4375 179.882812 -54.609375 178.589844 C -55.78125 177.296875 -56.917969 175.976562 -58.023438 174.625 C -59.132812 173.277344 -60.203125 171.902344 -61.246094 170.5 C -62.285156 169.101562 -63.289062 167.675781 -64.257812 166.222656 C -65.226562 164.773438 -66.160156 163.300781 -67.054688 161.804688 C -67.953125 160.308594 -68.8125 158.789062 -69.636719 157.25 C -70.457031 155.710938 -71.242188 154.15625 -71.988281 152.578125 C -72.734375 151 -73.441406 149.40625 -74.109375 147.792969 C -74.773438 146.183594 -75.402344 144.554688 -75.992188 142.914062 C -76.578125 141.269531 -77.125 139.613281 -77.632812 137.945312 C -78.136719 136.273438 -78.605469 134.59375 -79.027344 132.902344 C -79.453125 131.210938 -79.832031 129.507812 -80.175781 127.796875 C -80.515625 126.085938 -80.8125 124.367188 -81.066406 122.640625 C -81.324219 120.917969 -81.539062 119.183594 -81.707031 117.449219 C -81.878906 115.714844 -82.007812 113.972656 -82.09375 112.230469 C -82.179688 110.488281 -82.222656 108.746094 -82.222656 107 C -82.222656 105.257812 -82.179688 103.511719 -82.09375 101.769531 C -82.007812 100.027344 -81.878906 98.289062 -81.707031 96.550781 C -81.539062 94.816406 -81.324219 93.085938 -81.066406 91.359375 C -80.8125 89.632812 -80.515625 87.914062 -80.175781 86.203125 C -79.832031 84.492188 -79.453125 82.792969 -79.027344 81.097656 C -78.605469 79.40625 -78.136719 77.726562 -77.632812 76.054688 C -77.125 74.386719 -76.578125 72.730469 -75.992188 71.089844 C -75.402344 69.445312 -74.773438 67.820312 -74.109375 66.207031 C -73.441406 64.59375 -72.734375 63 -71.988281 61.421875 C -71.242188 59.847656 -70.457031 58.289062 -69.636719 56.75 C -68.8125 55.210938 -67.953125 53.695312 -67.054688 52.199219 C -66.160156 50.703125 -65.226562 49.226562 -64.257812 47.777344 C -63.289062 46.328125 -62.285156 44.902344 -61.246094 43.5 C -60.203125 42.097656 -59.132812 40.722656 -58.023438 39.375 C -56.917969 38.027344 -55.78125 36.707031 -54.609375 35.414062 C -53.4375 34.121094 -52.234375 32.855469 -51 31.625 C -49.765625 30.390625 -48.503906 29.1875 -47.210938 28.015625 C -45.917969 26.84375 -44.597656 25.707031 -43.25 24.597656 C -41.898438 23.492188 -40.523438 22.417969 -39.125 21.378906 C -37.722656 20.339844 -36.296875 19.335938 -34.847656 18.367188 C -33.394531 17.398438 -31.921875 16.464844 -30.425781 15.566406 C -28.929688 14.671875 -27.410156 13.8125 -25.875 12.988281 C -24.335938 12.167969 -22.777344 11.382812 -21.199219 10.636719 C -19.621094 9.890625 -18.027344 9.183594 -16.417969 8.515625 C -14.804688 7.847656 -13.175781 7.21875 -11.535156 6.632812 C -9.890625 6.046875 -8.238281 5.496094 -6.566406 4.992188 C -4.898438 4.484375 -3.214844 4.019531 -1.523438 3.597656 C 0.167969 3.171875 1.871094 2.789062 3.582031 2.449219 C 5.292969 2.109375 7.011719 1.8125 8.734375 1.554688 C 10.460938 1.300781 12.191406 1.085938 13.929688 0.914062 C 15.664062 0.742188 17.402344 0.617188 19.148438 0.53125 C 20.890625 0.445312 22.632812 0.402344 24.378906 0.402344 C 26.121094 0.402344 27.863281 0.445312 29.609375 0.53125 C 31.351562 0.617188 33.089844 0.742188 34.824219 0.914062 C 36.5625 1.085938 38.292969 1.300781 40.019531 1.554688 C 41.742188 1.8125 43.460938 2.109375 45.171875 2.449219 C 46.882812 2.789062 48.585938 3.171875 50.277344 3.597656 C 51.972656 4.019531 53.652344 4.484375 55.320312 4.992188 C 56.992188 5.496094 58.648438 6.046875 60.289062 6.632812 C 61.933594 7.21875 63.558594 7.847656 65.171875 8.515625 C 66.78125 9.183594 68.378906 9.890625 69.953125 10.636719 C 71.53125 11.382812 73.089844 12.167969 74.628906 12.988281 C 76.167969 13.8125 77.683594 14.671875 79.179688 15.566406 C 80.675781 16.464844 82.148438 17.398438 83.601562 18.367188 C 85.050781 19.335938 86.476562 20.339844 87.878906 21.378906 C 89.28125 22.417969 90.65625 23.492188 92.003906 24.597656 C 93.351562 25.707031 94.671875 26.84375 95.964844 28.015625 C 97.257812 29.1875 98.519531 30.390625 99.753906 31.625 C 100.988281 32.855469 102.191406 34.121094 103.363281 35.414062 C 104.535156 36.707031 105.671875 38.027344 106.78125 39.375 C 107.886719 40.722656 108.960938 42.097656 110 43.5 C 111.039062 44.902344 112.042969 46.328125 113.011719 47.777344 C 113.980469 49.226562 114.914062 50.703125 115.808594 52.199219 C 116.707031 53.695312 117.566406 55.210938 118.390625 56.75 C 119.210938 58.289062 119.996094 59.847656 120.742188 61.421875 C 121.488281 63 122.195312 64.59375 122.863281 66.207031 C 123.53125 67.820312 124.15625 69.445312 124.746094 71.089844 C 125.332031 72.730469 125.878906 74.386719 126.386719 76.054688 C 126.890625 77.726562 127.359375 79.40625 127.78125 81.097656 C 128.207031 82.792969 128.585938 84.492188 128.929688 86.203125 C 129.269531 87.914062 129.566406 89.632812 129.824219 91.359375 C 130.078125 93.085938 130.292969 94.816406 130.464844 96.550781 C 130.632812 98.289062 130.761719 100.027344 130.847656 101.769531 C 130.933594 103.511719 130.976562 105.257812 130.976562 107 Z M 130.976562 107 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f72f7bb67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 132 0 L 132 107 L 0 107 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 132,
    xlinkHref: "data:image/png;base64,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",
    id: "ad1194e852",
    height: 108,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e9e1658d5d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a6ba601bd2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 132,
    xlinkHref: "data:image/png;base64,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",
    height: 108,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(1.001799, 0, 0, 0.998201, -82.837305, -0.0000293517)",
    gradientUnits: "userSpaceOnUse",
    r: 107.1917,
    cx: 107.1917,
    id: "a3da053881",
    cy: 107.1917,
    fx: 107.1917,
    fy: 107.1917
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.799561%, 5.499268%, 37.298584%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.799561%, 5.499268%, 37.298584%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8e9286ddd3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 132,
    y: 0,
    height: 107
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "095659b789",
    patternUnits: "userSpaceOnUse",
    width: 132,
    patternTransform: "matrix(0.992686, 0, 0, 0.996265, 0.00934438, 0.401499)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 132 107",
    height: 107,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e9286ddd3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f72f7bb67)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#e9e1658d5d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -397.033065,
    fill: "url(#a3da053881)",
    width: 1879.989392,
    height: 926.211275,
    y: -623.10471
  })))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "5855ad89d3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 132,
    y: 0,
    height: 107
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#111ac74054)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#8aef042000)",
    d: "M 1.007812 0 L 1.007812 533 L 1078.992188 533 L 1078.992188 0 Z M 1.007812 0 ",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e64749dd72)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#1b84670f26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 476, 0.000000000000043449)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#022c06ce28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#895c778fe8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76cbd6cea1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020e5f",
    d: "M 93.835938 -32.433594 L 841.316406 -32.433594 L 841.316406 668.5 L 93.835938 668.5 Z M 93.835938 -32.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2b34f139f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3d6ad4d823)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.748598, 0, 0, 0.748598, 93.835588, -32.432532)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 500.039272 -0.00141814 C 223.877255 -0.00141814 0.000466279 209.603904 0.000466279 468.165315 C 0.000466279 726.721508 223.877255 936.32683 500.039272 936.32683 C 776.20129 936.32683 1000.078079 726.721508 1000.078079 468.165315 C 1000.078079 209.603904 776.20129 -0.00141814 500.039272 -0.00141814 Z M 500.039272 -0.00141814 ",
    stroke: "#020e5f",
    strokeWidth: 60,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a5f2d03330)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6cf1776dce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f72d8f2512)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44956d1a95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.960938 L 17.582031 0.960938 L 17.582031 16.257812 L 0.253906 16.257812 Z M 0.253906 0.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c6a8ce959d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d1bb6c893)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#89676c334e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1cb6dd407)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.648438 L 17.582031 0.648438 L 17.582031 15.945312 L 0.253906 15.945312 Z M 0.253906 0.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#71ef1a05a1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd12300390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f80b608562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f06bfecbf1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.207031 L 17.582031 0.207031 L 17.582031 15.503906 L 0.253906 15.503906 Z M 0.253906 0.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#25550c89ff)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#590c3602e1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f47ffcc4cf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9898c93484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.894531 L 17.582031 0.894531 L 17.582031 16.191406 L 0.253906 16.191406 Z M 0.253906 0.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d2ff90d8d9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72d45878ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9857422f8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ada1f80a8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.960938 L 18.414062 0.960938 L 18.414062 16.257812 L 1.085938 16.257812 Z M 1.085938 0.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#41f0c188f9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1bb581a9bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d6942f6e85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8bcc685215)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.960938 L 18.140625 0.960938 L 18.140625 16.257812 L 0.808594 16.257812 Z M 0.808594 0.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#72ab131978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc5a66dffb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9b0daab27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#103ec75c92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.648438 L 18.414062 0.648438 L 18.414062 15.945312 L 1.085938 15.945312 Z M 1.085938 0.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#951e65239a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5e2392ab2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#41385cea7a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2dff4331a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.207031 L 18.414062 0.207031 L 18.414062 15.503906 L 1.085938 15.503906 Z M 1.085938 0.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#59f0fad7b2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#938aa624d7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39012010f0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f5259b7f3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.648438 L 18.140625 0.648438 L 18.140625 15.945312 L 0.808594 15.945312 Z M 0.808594 0.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fdac8b7916)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0027de04aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d12a622e8e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#51a99d7665)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.894531 L 18.414062 0.894531 L 18.414062 16.191406 L 1.085938 16.191406 Z M 1.085938 0.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9c7b9e954e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de960a0f7f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7b96e5879)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c82b9f7e47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.207031 L 18.140625 0.207031 L 18.140625 15.503906 L 0.808594 15.503906 Z M 0.808594 0.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ff2f65d45c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1615c02f1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c12647447)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba23e6de06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.894531 L 18.140625 0.894531 L 18.140625 16.191406 L 0.808594 16.191406 Z M 0.808594 0.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#360f3ea620)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#767200edfa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2085d606d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8ad3edbd8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.578125 L 17.582031 0.578125 L 17.582031 15.875 L 0.253906 15.875 Z M 0.253906 0.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0d70e7e20f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 148)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c701e152f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac577808a7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38806ecc3f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.265625 L 17.582031 0.265625 L 17.582031 15.5625 L 0.253906 15.5625 Z M 0.253906 0.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#6fa29a67fb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1037, 173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0bc6aad9b0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10bf037f58)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58cd3b10fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.253906 0.824219 L 17.582031 0.824219 L 17.582031 16.121094 L 0.253906 16.121094 Z M 0.253906 0.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d2c627dfea)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46f3fafbb4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7730fe1c3b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#969a652df7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.578125 L 18.414062 0.578125 L 18.414062 15.875 L 1.085938 15.875 Z M 1.085938 0.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0082a7653f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#529fc0cd01)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e2f576f434)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5029d01429)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.578125 L 18.140625 0.578125 L 18.140625 15.875 L 0.808594 15.875 Z M 0.808594 0.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#76bf108c5f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 148)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#406777f744)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50c8caa0db)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6882cb4efd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.265625 L 18.414062 0.265625 L 18.414062 15.5625 L 1.085938 15.5625 Z M 1.085938 0.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3bb98e6768)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 988, 173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb2af828eb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#453a861d60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81154b7f05)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 1.085938 0.824219 L 18.414062 0.824219 L 18.414062 16.121094 L 1.085938 16.121094 Z M 1.085938 0.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#20d7111e79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 148)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13f346bcb1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d194636839)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67e0f80247)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.265625 L 18.140625 0.265625 L 18.140625 15.5625 L 0.808594 15.5625 Z M 0.808594 0.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eb039ec984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1010, 173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed2ad6529d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c833a4d29a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#22082a985f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455bee",
    d: "M 0.808594 0.824219 L 18.140625 0.824219 L 18.140625 16.121094 L 0.808594 16.121094 Z M 0.808594 0.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#3fba96cf06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 779, 250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90686f8e67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64f548a546)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f8bc9153d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.09375 0.441406 L 210.085938 0.441406 L 210.085938 210.433594 L 0.09375 210.433594 Z M 0.09375 0.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#206f01993f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 907, 339)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#674ef19dd0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1ffb6c8e5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea83372f6e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.742188 1.027344 L 121.148438 1.027344 L 121.148438 121.433594 L 0.742188 121.433594 Z M 0.742188 1.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc73dca021)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#aef9066ba4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1, 426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5855ad89d3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd1f6247b5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9287d418eb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#095659b789)",
    d: "M 0.0078125 0.402344 L 130.976562 0.402344 L 130.976562 107.003906 L 0.0078125 107.003906 Z M 0.0078125 0.402344 ",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBg);
export default __webpack_public_path__ + "static/media/blue-bg.37c8112575cde24d020312ddb665ee63.svg";
export { ForwardRef as ReactComponent };